import { combineReducers } from 'redux';
import cakeReducer from './Cake/cakeReducer';
import IceCreamReducer from './IceCream/IceCreamReducer';
import userReducer from './User/UserReducer';

//*****
//navigationReducer is important here, above reducers are added to  support and provide multiple reducers called combined reducers
//ignore above reducers and ignore ReduxExamples folder also
//you can understand a bit by seeing ReduxExamples folder if you are new to Redux usage
import navigationReducer from './Navigation/navigationReducer';

const rootReducer= combineReducers({
    cake: cakeReducer,
    iceCream: IceCreamReducer,
    user: userReducer,
    navs: navigationReducer
})

export default rootReducer;